export default __webpack_public_path__ + "static/media/corn.1bc3431b.png";